/**
 * Compact AI summary of the correlation matrix, seen from one anchor effect:
 * the anchor's row without the diagonal. Dutch keys — the summary is embedded
 * verbatim in Decca's Dutch analysis prompt.
 * Pure function — no Firebase imports.
 */

/**
 * @typedef {import('./buildCorrelationMatrix').CorrelationMatrix} CorrelationMatrix
 */

/**
 * @param {CorrelationMatrix|null} matrix - buildCorrelationMatrix output
 * @param {string} anchorId - Effect ID whose row to summarize
 * @returns {Array<{effect: string, r: number|null, gedeeldeDeelnemers: number}>|null}
 */
const summarizeAnchorCorrelations = (matrix, anchorId) => {
    if (!matrix || !anchorId || !matrix.cells?.[anchorId]) return null

    const rows = matrix.effects
        .filter((e) => e.id !== anchorId)
        .map((e) => {
            const cell = matrix.cells[anchorId][e.id]
            const hasR = cell && cell.r !== null && !cell.insufficient
            return {
                effect: e.name,
                r: hasR ? Math.round(cell.r * 100) / 100 : null,
                gedeeldeDeelnemers: cell ? cell.n : 0,
            }
        })

    return rows.length ? rows : null
}

export default summarizeAnchorCorrelations
